import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Post,CreatePostDto } from "../models/Post";
import axios from "../utils/axios";

interface PostState {
posts: Post[];
  selectedPost: Post | null;
  error: { message: string; code: string };
  loading: boolean;
  searchResults: Post[];
}

const initialState: PostState = {
    posts: [],
    selectedPost: null,
    error: { message: "", code: "" },
    loading: false,
    searchResults: [],
};

export const createPost = createAsyncThunk(
  "posts/create",
  async (post: CreatePostDto,{ rejectWithValue }) => {
    try{
        const response = await axios.post("api/services/app/Post/Create", post);
    return response.data;
    }catch (error: any) {
       return rejectWithValue({ message: error.message, code: error.code });
    }
  }
);

export const fetchPosts = createAsyncThunk(
  "posts/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("api/services/app/Post/GetAll");
      return response.data.result.items as Post[];
    } catch (error: any) {
      return rejectWithValue({ message: error.message, code: error.code });
    }
  }
);

export const updatePost = createAsyncThunk(
  "posts/update",
  async (post: Post, { rejectWithValue }) => {
    try {
      const response = await axios.put(`api/services/app/Post/Update/${post.id}`, post);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({ message: error.message, code: error.code });
    }
  }
);

export const searchPosts = createAsyncThunk(
  "posts/search",
  async (payload: { keyword: string }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`api/services/app/Post/Search?keyword=${payload.keyword}`);
      return response.data.result.items as Post[];
    } catch (error: any) {
      return rejectWithValue({ message: error.message, code: error.code });
    }
  }
);

export const deletePost = createAsyncThunk(
  "posts/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      await axios.delete(`api/services/app/Post/Delete/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue({ message: error.message, code: error.code });
    }
  }
);

export const getAllPosts = createAsyncThunk(
  "posts/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("api/services/app/Post/GetAll");
      return response.data.result.items as Post[];
    } catch (error: any) {
      return rejectWithValue({ message: error.message, code: error.code });
    }
  }
);

export const postSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    setselectedPost: (state, action: PayloadAction<Post | null>) => {
      state.selectedPost = action.payload;
    },
    clearselectedPost: (state) => {
      state.selectedPost = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPost.fulfilled, (state, action) => {
        state.posts.push(action.payload);
      })
      .addCase(createPost.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPost.rejected, (state, action) => {
        state.error = {message:'',code:''}//{ message:action.payload.message, code: action.payload.code };
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.posts = action.payload;
        state.loading = false;
      })
      .addCase(fetchPosts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.error = {message:'',code:''}//{ message:action.payload.message, code: action.payload.code };
        state.loading = false;
      })
      .addCase(updatePost.fulfilled, (state, action) => {
        const index = state.posts.findIndex((post) => post.id === action.payload.id);
        if (index !== -1) {
          state.posts[index] = action.payload;
        }
      })
      .addCase(updatePost.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePost.rejected, (state, action) => {
        state.error = {message:'',code:''}//{ message:action.payload.message, code: action.payload.code };
      });
    }
});

export const { setselectedPost, clearselectedPost } = postSlice.actions;

export default postSlice.reducer;
